import React from 'react';
import { initializeIcons } from '@uifabric/icons';
import {
    TextField,
    DefaultButton,
    SearchBox,
    IIconProps,
    PrimaryButton,
    Spinner,
    SpinnerSize
} from 'office-ui-fabric-react';

import { Component } from 'react';

import '../styles/simpleview.css';

interface IState {
    token: string;
    name: string;
    image: string;
    userName: string;
    userId: string;
    firstName: string;
    originalURL: string;
    items: any[];
    searchLabel: string;
    searchText: string;
    matterURL: string;
    globalsearchURL: string;
    formActionURL: string;
    formTarget: string;
    blocking: boolean;
}

const filterIcon: IIconProps = { iconName: 'none' };

const queryString = ((a) => {
    if (a == "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i) {
        var p = a[i].split('=', 2);
        if (p.length == 1)
            b[p[0]] = "";
        else
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
})(window.location.search.substr(1).split('&'));

class SimpleView extends Component<{}, IState> {

    constructor(props: {}) {
        super(props);

        this.state = {
            token: '',
            name: '',
            image: '',
            userName: '',
            firstName: '',
            userId: '',
            originalURL: '',
            items: [],
            searchLabel: 'Search',
            searchText: '',
            matterURL: '',
            globalsearchURL: '',
            formActionURL: '',
            formTarget: '',
            blocking: false,
            hasv1Access: queryString['hv1'],
            hasv2Access: queryString['hv2']
        };
    }

    onSearchClicked = () => {
        let userSession = JSON.parse(localStorage.getItem('userSession'));
        let encodedImageString = window.btoa(userSession.image);
        let originalURL = this.state.globalsearchURL + '?search=' + this.state.searchText;
        let formUrl = this.state.globalsearchURL + '?search=' + this.state.searchText;
        let target = '';
        let blockedUI = false;

        if (this.state.searchLabel === 'Search') {
            target = '';
            blockedUI = true;
            formUrl = this.state.globalsearchURL + '?search=' + this.state.searchText + "&sec=" + queryString['sec'];
            originalURL = this.state.globalsearchURL + '?search=' + this.state.searchText + "&sec=" + queryString['sec'];
        } else {
            target = '_blank';
            blockedUI = false;
            formUrl = this.state.matterURL + '/Route/PostToken';
            originalURL = this.state.matterURL + '/Matter?matterCode=' + this.state.searchText + '#/Documents';
        }

        this.setState({
            formActionURL: formUrl,
            formTarget: target,
            name: userSession.name,
            token: userSession.token,
            image: encodedImageString,
            userName: userSession.userName,
            userId: userSession.id,
            originalURL: originalURL,
            blocking: blockedUI
        });
    }

    onGotoMatter = () => {
        window.open(
            this.state.matterURL + '/Matter?matterCode=' + this.state.searchText + '#/Documents',
            '_blank'
        );
    }

    getUserSession = () => {
        // Get current user name
        let userSession = JSON.parse(localStorage.getItem('userSession'));
        let fullname = userSession.name;
        let spaceIndex = fullname.indexOf(' ');
        let firstname = fullname;
        if (spaceIndex > 0) {
            firstname = fullname.substring(0, spaceIndex);
        }

        // Get API URL
        let apiURL = JSON.parse(localStorage.getItem('api'));

        this.setState({
            firstName: firstname,
            matterURL: apiURL.matterdetail,
            globalsearchURL: apiURL.globalsearch
        });
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('load-trigger', this.getUserSession);
        }

        this.getUserSession();
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('load-trigger', this.getUserSession);
        }
    }

    onTextChanged = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {
        const matterFormatOne = new RegExp('^[A-Za-z]{1}\\\d{4}-\\\d{5}$');
        const matterFormatTwo = new RegExp('^\\\d{5}-\\\d{5}$');

        if (matterFormatOne.test(text.trim()) || matterFormatTwo.test(text.trim())) {
            this.setState({
                searchLabel: 'Go to Matter',
                searchText: text.trim()
            });
        } else {
            this.setState({
                searchLabel: 'Search',
                searchText: text.trim()
            });
        }
    }

    public render() {
        return (
            <form id='form-simpleview' action={this.state.formActionURL} target={this.state.formTarget} method='post'>
                {this.state.blocking === true ?
                    <Spinner className='spinner' size={SpinnerSize.large} label='Loading...' ariaLive='assertive' labelPosition='top' />
                    : ''
                }
                <input type='hidden' name='token' value={this.state.token}></input>
                <input type='hidden' name='image' value={ this.state.image}></input>
                <input type='hidden' name='name' value={ this.state.name}></input>
                <input type='hidden' name='userName' value={this.state.userName}></input>
                <input type='hidden' name='userId' value={this.state.userId}></input>
                <input type='hidden' name='originalIUrl' value={ this.state.originalURL}></input>
                <div>
                    <div className='search-container'>
                        <div className='row'>
                            <div className='welcome-text'>
                                Welcome, {this.state.firstName}
                            </div>
                        </div>
                        <div className='row'>
                            <div className={(this.state.hasv1Access !== null && this.state.hasv1Access == "true") || (this.state.hasv2Access !== null && this.state.hasv2Access == "true") ? 'search-holder' : 'search-holder disabled'}>
                                <SearchBox onChange={this.onTextChanged} placeholder='Search' iconProps={filterIcon} />
                                <PrimaryButton type='submit' className='search-btn' onClick={this.onSearchClicked} text={this.state.searchLabel} disabled={!((this.state.hasv1Access !== null && this.state.hasv1Access == "true") || (this.state.hasv2Access !== null && this.state.hasv2Access == "true"))} /> 
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default SimpleView;